import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { aiInsightsAllowedEmails, ENVIRONMENT } from '@agilox/common';
import { UserStoreService } from '@user-store';
import { MenuPointUrl } from '../shared/enums';

export const aiInsightsGuard: CanActivateFn = (): boolean | UrlTree => {
	const userStore = inject(UserStoreService);
	const router = inject(Router);
	const environment = inject(ENVIRONMENT);
	const user = userStore.currentUser();

	const hasAccess =
		!!environment.agentApi &&
		user?.email &&
		aiInsightsAllowedEmails.includes(user.email.toLowerCase());

	if (hasAccess) {
		return true;
	}

	return router.parseUrl(MenuPointUrl.dashboards);
};
